type ValueType = string | number | boolean | undefined;

type Matrix = ValueType[][];

/**
 * The matrix transpose function
 */
export const transpose = (matrix: Matrix): Matrix => {
  const longestRowLength = Math.max(...matrix.map((row) => row.length));

  return Array.from({ length: longestRowLength }, (_, column) => matrix.map((row) => row[column]));
};
